import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import DescriptionIcon from '@material-ui/icons/Description';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface ProductDetailSpagettyDocumentsProps extends StandardDivProps<ProductDetailSpagettyDocumentsClassKey> {
  anchor?: string;
  onNaviButtonShow?: (state?: boolean) => void;
  product: ProductDetailProduct;
}

export type ProductDetailSpagettyDocumentsClassKey = 'root' | 'headline' | 'link';

const themeSettings = { name: 'ProductDetailSpagettyDocuments' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<ProductDetailSpagettyDocumentsClassKey, {}>({
      root: {},
      headline: {
        ...theme.typography.h4,
      },
      link: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '1rem',
        margin: theme.spacing(1, 0),
        '& svg': {
          marginRight: theme.spacing(1),
        },
      },
    }),
  themeSettings,
);

const ProductDetailSpagettyDocuments = React.forwardRef<HTMLDivElement, ProductDetailSpagettyDocumentsProps>(
  ({ anchor, className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const t = useTranslateWithFallback();

    return (
      <div ref={ref} className={clsx(classes.root, className)} id={anchor ? anchor.replace('#', '') : undefined}>
        <h2 className={classes.headline}>{t('productDetailPage/documents')}</h2>
        {product?.documents?.map((doc) => (
          <Link key={doc.url} className={classes.link} href={doc.url} target='_blank' rel='noreferrer'>
            <DescriptionIcon />
            <span> {t(doc.description ?? doc.name)}</span>
          </Link>
        ))}
      </div>
    );
  },
);

ProductDetailSpagettyDocuments.displayName = 'ProductDetailSpagettyDocuments';

export default withThemeProps(themeSettings)(ProductDetailSpagettyDocuments);
